module.exports = __webpack_public_path__ + "static/media/DonateCarousel_1-desktop.9af110d3.jpeg";